/**
 * Created by Mark on 18/04/2017.
 */


import ApplicationServices from './base-service.js';
import Constants from '../constants/classes.js';
import Action    from '../actions/default.js';

class ClassService {

    constructor(){
        this.isAuthenticated = false;
        this.timeout = null;
    }

    doesNameExist(className){
        return ApplicationServices.call(Constants.VALIDATE_CLASS_NAME_CALL , {className:className }).then(function(response){
            return response['isValid'];
        });
    }

    getProgressReportData(classID  , from , to , languageValue){
        return ApplicationServices.call(Constants.GET_PROGRESS_REPORTS , {languageID:languageValue , from:from , to:to , classID:classID})
    }

    createNewClass(className , students , allLanguages , selectedlanguages , shareTeachers){
        return ApplicationServices.call(Constants.CREATE_CLASS , {className:className , students:students , allLanguages:allLanguages , selectedlanguages:selectedlanguages , shareTeachers:shareTeachers}).then(function(response){
            return response['class_uid'];
        });
    }

    getViewableClasses(){
        return ApplicationServices.call(Constants.GET_VIEWABLE_CLASS_CALL , {}).then(function(response){
            Action.update(Constants.UPDATE_CLASSES , response.classes);
        });
    }

    getViewableClassesNameList(){

        return ApplicationServices.call(Constants.GET_VIEWABLE_CLASS_NAMES , {}).then(function(response){
            Action.update(Constants.UPDATE_NAMES_CLASSES_LIST , response.name_list);
        });
    }

    getClass(classID){
        return ApplicationServices.call(Constants.GET_CLASS , {classID:classID}).then(function(response){
            Action.update(Constants.UPDATE_CLASS , response.class);
        });
    }

    getClassActivity(classID  , from , to , languageValue){
        return ApplicationServices.call(Constants.GET_CLASS_ACTIVITY , {languageID:languageValue , from:from , to:to , classID:classID}).then(function(response){
            Action.update(Constants.UPDATE_CLASS_ACTIVITY , response.activity);
        });
    }

    addStudents(students , classID){
        return ApplicationServices.call(Constants.ADD_STUDENTS , {students:students , classID:classID }).then(function(response){

        });
    }

    deleteClass(classID){
        return ApplicationServices.call(Constants.DELETE_CLASS , {classID:classID }).then(function(response){
            response.complete
        });
    }


    editClass(classID , className , allLanguages , selectedlanguages , shareTeachers){

        return ApplicationServices.call(Constants.EDIT_CLASS , {
            classID:classID ,
            className:className,
            allLanguages:allLanguages,
            selectedlanguages:selectedlanguages,
            shareTeachers:shareTeachers
        }).then(function(response){
            response.complete
        });
    }

    removeUser(classID , userID)
    {
        return ApplicationServices.call(Constants.REMOVE_STUDENT , {classID:classID  , userID:userID }).then(function(response){
            response.complete
        });
    }

}


export default new ClassService();


// WEBPACK FOOTER //
// ./src/services/classes-service.js